/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  syncWhatsappTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates/sync`);
  }

  uploadTemplateAsset(inboxId, formData) {
    return axios.post(
      `${this.url}/${inboxId}/upload_template_asset`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }

  createCsatTemplate(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, payload);
  }

  getWhatsappTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  createWhatsappTemplate(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, payload);
  }

  updateWhatsappTemplate(inboxId, templateId, payload) {
    const encodedTemplateId = encodeURIComponent(templateId);
    return axios.patch(
      `${this.url}/${inboxId}/whatsapp_templates/${encodedTemplateId}`,
      payload
    );
  }

  deleteWhatsappTemplate(inboxId, templateName) {
    const encodedTemplateName = encodeURIComponent(templateName);
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_templates/${encodedTemplateName}`
    );
  }
}

export default new Inboxes();
